var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogoDrak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    viewBox: "0 0 62 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8036 37.3333C37.8036 44.1802 34.1168 50.17 28.6254 53.4094L23.6808 48.4607C22.4954 47.2744 20.8746 46.6642 19.1957 46.6642C24.3242 46.6449 28.4851 42.4757 28.4851 37.3333C28.4851 32.1909 24.3339 28.0266 19.2054 28.0024H19.2973C20.9036 28.0266 22.4567 27.4359 23.5888 26.298L28.6303 21.2524C34.1265 24.4967 37.8084 30.4865 37.8084 37.3285L37.8036 37.3333Z",
    fill: "#8D9199"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6759 48.4607L28.6206 53.4094C25.8338 55.0606 22.5825 56.0048 19.1086 55.9952C9.19026 55.9758 0.912052 48.0201 0.515317 38.0984C0.0895526 27.4407 8.59516 18.6667 19.1522 18.6667C22.6115 18.6667 25.8483 19.6061 28.6206 21.2524L23.5792 26.298C22.4422 27.4359 20.8891 28.0218 19.2828 28.0024C19.2538 28.0024 19.2248 28.0024 19.1957 28.0024C14.4591 27.9782 10.5014 31.3968 9.90148 36.1034C9.17091 41.8075 13.5931 46.6691 19.1473 46.6691C19.157 46.6691 19.1619 46.6691 19.1715 46.6691C20.8552 46.6691 22.4809 47.2744 23.6711 48.4655L23.6759 48.4607Z",
    fill: "#C3C6CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4078 39.9723L44.3932 56C40.75 52.3538 40.75 46.4463 44.3932 42.8002L56.4501 30.7334L60.4078 34.6943C61.8641 36.1518 61.8641 38.5148 60.4078 39.9723Z",
    fill: "#8D9199"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82407 9.33091V21.1604C4.25527 24.3901 0.500802 30.4235 0.500802 37.3333V0C5.65352 0 9.82407 4.17882 9.82407 9.33091Z",
    fill: "#C3C6CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4078 39.9723L56.4501 43.9332L44.3932 31.8665C40.75 28.2203 40.75 22.3128 44.3932 18.6667L60.4078 34.6943C61.8641 36.1518 61.8641 38.5148 60.4078 39.9723Z",
    fill: "#C3C6CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4924 47.8942C54.6793 45.7055 54.6793 42.161 52.4924 39.9723L56.4501 43.9332L52.4924 47.8942Z",
    fill: "#C3C6CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogoDrak);
export default __webpack_public_path__ + "static/media/small-logo-drak.193ec9f5f84b6a78020608ce38daba91.svg";
export { ForwardRef as ReactComponent };